import { Component, ElementRef, Inject, Input, SimpleChanges, ViewChild, DOCUMENT } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { environment } from '../../../environments/environment';
import { IsDesktopService } from '../services/is-desktop.service';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { IsSidebarOpenService } from '../services/is-sidebar-open.service';
import { Router, RouterLink } from '@angular/router';
import { DataContext } from '../../my-meet/models/data-context.model';
import { AppToastService } from '../toast/toast-service/app-toast.service';
import { FollowButtonComponent } from '../follow-button/follow-button.component';
import { CurrentMeetService } from '../services/current-meet.service';
import { SiteConfigInterface } from '../models/config/site-config.interface';
import { SiteConfigService } from '../services/site-config.service';
import { SeoService } from '../services/seo.service';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { IsDarkModeService } from '../services/is-dark-mode.service';
import { EventDateComponent } from 'src/app/event/event-date/event-date.component';
import { MeetDateService } from '../meet-date/meet-date.service';

@Component({
  selector: 'app-page-title',
  imports: [CommonModule, FontAwesomeModule, FollowButtonComponent, RouterLink, EventDateComponent],
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent {
  @ViewChild('pageTitle') pageTitle!: ElementRef<HTMLElement>;
  // @ViewChild('star') star!: FaIconComponent;
  @Input() avatarInitals?: string;
  @Input() title!: string;
  @Input() titleIcon!: string;
  @Input() profilePicture!: string;
  @Input() subtitle!: string;
  @Input() canonicalPath!: string;
  @Input() sharePath!: string;
  @Input() dataContext!: DataContext;
  @Input() showShare: boolean = true;
  @Input() showFollow: boolean = false;
  @Input() addMarginBottom: boolean = true;
  @Input() desktopOverrideTitle!: string | null;
  @Input() desktopOverrideSubtitle!: string | null;
  @Input() noIndex: boolean = false; // Crawling meta tag
  @Input() noFollow: boolean = false; // Crawling meta tag
  @Input() eventDate: string | null = null;
  meet!: MeetList | null;
  desktop!: boolean;
  observer!: IntersectionObserver;
  displaySubtitle!: string;
  displayTitle!: string;
  desktop$!: Observable<boolean>;
  isDarkMode$!: Observable<boolean>;
  currentMeetSub!: Subscription;
  siteConfig$!: Observable<SiteConfigInterface | null>;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private isDesktopService: IsDesktopService,
    public isSidebarOpenService: IsSidebarOpenService,
    protected router: Router,
    protected toastService: AppToastService,
    protected siteConfigService: SiteConfigService,
    private isDarkModeService: IsDarkModeService,
    protected currentMeetService: CurrentMeetService,
    protected seoService: SeoService,
    protected meetDateService: MeetDateService,
  ) {}

  back() {
    //console.log('go back');
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['title'] && !changes['title'].isFirstChange()) {
      await this.setTitles();
    }
    if (
      (changes['noIndex'] && !changes['noIndex'].isFirstChange()) ||
      (changes['noFollow'] && !changes['noFollow'].isFirstChange())
    ) {
      console.log('noIndex or noFollow changed');
      console.log(changes['noIndex'].currentValue, changes['noFollow'].currentValue);
      this.seoService.setRobotTags(changes['noIndex'].currentValue, changes['noFollow'].currentValue);
    }
  }

  async ngOnInit() {
    //console.log('init page title');
    this.isDarkMode$ = this.isDarkModeService.isDarkMode;
    this.desktop$ = this.isDesktopService.isDesktop;
    this.siteConfig$ = this.siteConfigService.updateSiteConfig;
    this.currentMeetSub = combineLatest([
      this.currentMeetService.updateMeet,
      this.isDesktopService.isDesktop,
    ]).subscribe(async ([meet, desktop]: [MeetList | null, boolean]) => {
      this.meet = meet;
      this.desktop = desktop;
      this.seoService.setRobotTags(this.noIndex, this.noFollow);
      await this.setTitles();
    });
  }

  async setTitles() {
    await this.seoService.setTitle(this.title);
    this.seoService.setCanonicalUrl(
      this.document.location.origin + (this.canonicalPath ? this.canonicalPath : this.router.url),
    );
    if (this.meet) {
      if (this.meet.name === this.title || this.meet.longName === this.title) {
        this.displaySubtitle = this.meetDateService.transform(
          this.meet.meetDates,
          this.meet.timeFormat,
          this.meet.dateString,
        );
      } else {
        this.displaySubtitle =
          this.meet.name +
          ' | ' +
          this.meetDateService.transform(this.meet.meetDates, this.meet.timeFormat, this.meet.dateString);
      }
      if (
        this.subtitle &&
        this.subtitle !==
          this.meetDateService.transform(this.meet.meetDates, this.meet.timeFormat, this.meet.dateString)
      ) {
        this.displaySubtitle = this.subtitle + ' | ' + this.displaySubtitle;
      }
      if (this.desktop) {
        if (this.desktopOverrideTitle) {
          this.displayTitle = this.desktopOverrideTitle;
        } else {
          this.displayTitle = this.title;
        }
        if (this.desktopOverrideSubtitle) {
          this.displaySubtitle = this.desktopOverrideSubtitle;
        } else if (this.desktopOverrideSubtitle === null) {
          this.displaySubtitle = '';
        }
      } else {
        this.displayTitle = this.title;
      }
    } else {
      this.displayTitle = this.title;
      this.displaySubtitle = this.subtitle;
    }
  }

  // ngAfterViewInit() {
  //   // https://www.smashingmagazine.com/2021/07/dynamic-header-intersection-observer/
  //   //https://codepen.io/michellebarker/full/xxwLpRG
  //   this.observer = new IntersectionObserver(
  //     ([e]) => {
  //       // console.log("in IntersectionObserver callback");
  //       // console.log(e);
  //       e.target.classList.toggle("is-pinned", e.intersectionRatio < 1)
  //     },
  //     {
  //       rootMargin: '-56px 0px 0px 0px',
  //       threshold: [1]
  //     }
  //   );
  //
  //   this.observer.observe(this.pageTitle.nativeElement);
  // }

  ngOnDestroy() {
    //this.observer.disconnect();
    if (this.currentMeetSub) {
      this.currentMeetSub.unsubscribe();
    }
  }

  share() {
    const url = this.document.location.origin + (this.sharePath ? this.sharePath : this.router.url);
    if ('share' in this.document.defaultView.navigator) {
      this.document.defaultView.navigator.share({
        url,
        title: this.title,
      });
    } else {
      // copy link to clipboard
      this.document.defaultView.navigator.clipboard.writeText(url);
      this.toastService.show('Success', 'Link copied to clipboard');
    }
  }

  protected readonly environment = environment;
}
